import { render, staticRenderFns } from "./OrgSignedStatsByType.vue?vue&type=template&id=2df6444a&scoped=true&"
import script from "./OrgSignedStatsByType.vue?vue&type=script&lang=js&"
export * from "./OrgSignedStatsByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df6444a",
  null
  
)

export default component.exports